import { render, staticRenderFns } from "./NewConsentForm.vue?vue&type=template&id=5e9f45c5&scoped=true&"
import script from "./NewConsentForm.vue?vue&type=script&lang=ts&"
export * from "./NewConsentForm.vue?vue&type=script&lang=ts&"
import style0 from "./NewConsentForm.vue?vue&type=style&index=0&id=5e9f45c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9f45c5",
  null
  
)

export default component.exports